import { httpClient } from './httpClient'
import type { BugReportDto, CreateBugReportRequest } from '../dto/admin/BugReportDto'

export const bugReportApi = {
  create: (request: CreateBugReportRequest) => httpClient.post<BugReportDto>('/bug-reports', request),
}
